import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import Consultations from '@services/Consultations'
import { fromNow } from '@utilities/date'
import ReviewForm from './Room.Show.Review.Form'

export class RoomReview extends Component {
  state = {
    reviews: [],
  }

  reviewClient = Consultations.reviews

  fetchReviews = () => {
    this.reviewClient.fetchRoomReviews(this.props.room.id).then((res) => this.setState({ reviews: res.data }))
  }

  onCreateReviewSuccess = (review) => {
    this.setState((oldState) => ({ reviews: [review, ...oldState.reviews] }))
  }

  componentDidMount() {
    this.fetchReviews()
  }

  render() {
    const { reviews } = this.state
    const { room, userId } = this.props

    return (
      <>
        <div className="review-info-professional">
          <div className="professional-avatar">
            <img src={room.professional.avatar} alt="avatar" />
          </div>
          <div>
            <div>{room.professional.name}</div>
            <div style={{ fontSize: 15 }}>{room.professional.email}</div>
          </div>
        </div>

        <div className="title-section-reviews">
          <Trans>Añadir Revisión</Trans>
        </div>
        <ReviewForm room={room} userId={userId} onSuccess={this.onCreateReviewSuccess} />

        <div className="title-section-reviews">
          <Trans>Historial de Revisiones</Trans>
        </div>

        {reviews
          .sort((a, b) => b.id - a.id)
          .map((review) => (
            <div className="record" key={review.id}>
              <div className="doctor-name">
                {review.reviewer && review.reviewer.name} - <b>{review.score}</b>
              </div>
              <div className="doctor-name">
                <span className="time"> {fromNow(review.created_at)}</span>
              </div>
              <div className="review-info">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {' '}
                    <Trans>Consulta resuelta</Trans> {review.anamnesis}
                  </span>
                  <span>
                    {' '}
                    <Trans>Seguimiento</Trans> {review.follow}
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {' '}
                    <Trans>Soporte imagen</Trans> {review.media}
                  </span>
                  <span>
                    {' '}
                    <Trans>Derivación</Trans> {review.derivation}
                  </span>
                </div>
                <div>
                  <Trans>Observaciones</Trans> {review.observations}
                </div>
              </div>
            </div>
          ))}
      </>
    )
  }
}
